import { EllipsisOutlined, ReloadOutlined, ToolOutlined } from '@ant-design/icons';
import { Button, Dropdown, Layout, Menu, Modal, PageHeader, Table, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { SystemSetting } from '../../../models';
import { apiClient, apiErrorMessage } from '../../../utils';
import { EntityChangeLog } from '../../reports';

export function SystemSettingsPage() {
  const { Content } = Layout;
  const { Text } = Typography;

  const [loading, setLoading] = useState(false);
  const [systemSettings, setSystemSettings] = useState<(SystemSetting & { key: string })[]>();
  const [changeLogModalOpen, setChangeLogModalOpen] = useState<string>();

  useEffect(() => {
    loadSystemSettings();
  }, []);

  const loadSystemSettings = () => {
    setLoading(true);
    apiClient
      .get('system-settings')
      .then(response => {
        const responseRoles: SystemSetting[] = response.data;
        const responseData = responseRoles.map(systemSetting => {
          return {
            key: systemSetting.id,
            ...systemSetting,
          };
        });
        setSystemSettings(responseData);
        setLoading(false);
      })
      .catch((reason: any) => {
        setLoading(false);
        apiErrorMessage(reason);
      });
  };

  const openChangeLogModal = (id: string) => {
    setChangeLogModalOpen(id);
  };

  const closeChangeLogModal = () => {
    setChangeLogModalOpen(undefined);
  };

  const onValueChange = (id: string) => (newValue: string) => {
    setLoading(true);
    apiClient
      .put(`system-settings/${id}`, { value: newValue })
      .then(() => {
        setLoading(false);
        loadSystemSettings();
      })
      .catch((reason: any) => {
        setLoading(false);
        apiErrorMessage(reason);
      });
  };

  const onRefreshClick = () => {
    loadSystemSettings();
  };

  const onTableActionClick = (e: any, id: string) => {
    if (e.key === 'changelog') {
      openChangeLogModal(id);
    }
  };

  const tableActions = (id: string) => (
    <Menu onClick={(e: any) => onTableActionClick(e, id)}>
      <Menu.Item key="changelog">
        <Text>Değişim geçmişi</Text>
      </Menu.Item>
    </Menu>
  );

  const tableColumns = [
    {
      title: 'İsim',
      dataIndex: 'id',
      key: 'name',
    },
    {
      title: 'Açıklama',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Değer',
      dataIndex: 'value',
      key: 'value',
      render: (value: string, systemSetting: SystemSetting) => (
        <div style={{ width: '20rem' }}>
          <Text editable={{ onChange: onValueChange(systemSetting.id) }}>{value}</Text>
        </div>
      ),
    },
    {
      title: '',
      key: 'action',
      render: (_: any, systemSetting: SystemSetting) => (
        <div style={{ textAlign: 'right' }}>
          <Dropdown overlay={tableActions(systemSetting.id)} trigger={['click']}>
            <Button size="small" icon={<EllipsisOutlined />} />
          </Dropdown>
        </div>
      ),
    },
  ];

  return (
    <>
      <PageHeader
        title={
          <>
            <ToolOutlined /> Sistem ayarları
          </>
        }
        extra={[
          <Button key="refresh" onClick={onRefreshClick} icon={<ReloadOutlined />}>
            Yenile
          </Button>,
        ]}
      />
      <Content>
        <Table columns={tableColumns} dataSource={systemSettings} loading={loading} scroll={{ x: '100%' }} pagination={false} />
      </Content>
      <Modal
        title="Sistem ayarları değişim geçmişi"
        visible={changeLogModalOpen !== undefined}
        footer={null}
        onCancel={closeChangeLogModal}
        destroyOnClose={true}
        width={'80%'}
      >
        <EntityChangeLog entityName={'SystemSetting'} recordId={changeLogModalOpen} />
      </Modal>
    </>
  );
}
